module.exports = __webpack_public_path__ + "img/specif_srb.1977ae96.jpg";